import { memo, useEffect, useRef, useState } from 'react'
// import * as THREE from 'three'
import { useFrame } from '@react-three/fiber'
import { Html } from '@react-three/drei'
import { config } from '../../config'

export const Caption3d = memo((props: any) => {
  const { refCanvas, mode = 0 } = props

  const gRef = useRef(null)
  const mRef = useRef<number>(0)
  const tRef = useRef<number>(0)
  const htmlRef = useRef(null)
  const htmlRefEn = useRef(null)

  const [userLang, setUserLang] = useState<string>('ja')
  const [cWidth, setCWidth] = useState<number|string>('33vw')
  const [fSize, setFSize] = useState<number|string>('10px')

  useEffect(() => {
    const rootElement = document.getElementById('root')
    if (!rootElement) return

    setUserLang(window.navigator.languages.indexOf('ja') != -1 ? 'ja' : 'en')
    // setUserLang(window.navigator.languages.indexOf('ja') == 0 ? 'ja' : 'en')

    const handleResize = () => {
      const canvas = refCanvas.current
      if (!canvas) return
      const width = canvas.offsetWidth
      const height = canvas.offsetHeight
      console.log(width, height)
      // TODO:
      setCWidth(width <= config.MOBILE_WIDTH ? `${width*Math.min(width, height)/Math.max(width, height)*0.975}px` : `${Math.min(width, height)*0.265}px`)
      setFSize(width <= config.MOBILE_WIDTH ? `8px` : `10px`)
    }
    handleResize()

    const observer = new ResizeObserver(() => {
      handleResize()
    })

    observer.observe(rootElement)

    return () => {
      observer.disconnect()
    }
  }, [])

  useEffect(() => {
    mRef.current = mode
  }, [mode])

  useFrame(_ => {
    if (gRef.current && mRef.current >= 0) {
      if (tRef.current > 0.1) {
        gRef.current.visible = false

        if (htmlRef.current) {
          htmlRef.current.style.display = 'none'
        }

        if (htmlRefEn.current) {
          htmlRefEn.current.style.display = 'none'
        }
      } else {
        tRef.current += 0.001
        gRef.current.translateZ(tRef.current)
        // gRef.current.scale.x = Math.max(0, (tRef.current * 4) + 1)
        // gRef.current.scale.y = Math.max(0, (tRef.current * 4) + 1)
      }
    }
  })

  /*
  このプロジェクトに関しては、何となく計画した通りに進んできたような気もしますが、過去から現在が組み立てられてきた構築的な感覚はなく、曖昧になってしまった現在と過去の繋がりを何とか結びつけている感覚があります。
  特にこの３年における過去と現在の繋がりがぼんやりして感じるのは個人的事情もあると思いますが、客観的にもあまりに激動の時代でした。
  侵略戦争が世界各地で勃発し、コロナ禍があっけなく忘却され、世界に対する不安と疑念は深まるばかりです。\r\nそんな状況だからなのでしょうか、アーティスト達の人間的な変化は大きく、３年前と別人だとすら感じてしまいます。
  今回のプロジェクトは360度カメラで、横浜美術館内部でアーティスト達のパフォーマンスを撮影した内容ですが、あえて過去と現在の映像を混在させて編集することで、現在の視点から薄くぼやけた３年前の美術館、アーティスト達の姿を再発見します。
  \r\nその瞬間が過去なのか現在なのかわからない状況を、360度カメラの幽体離脱した視点で追いかけながら、鑑賞者である皆さん達の３年間を追いかける機会になればと望んでいます。"
   */

  return (
    <group ref={gRef}>
      {userLang == 'ja' && (
        <Html ref={htmlRef}
          // position={[-3.6, 0, -4.6]}
          // rotation={[0, 0.5, 0]}
          transform occlude>
          <main className="caption">
            <div className={mode >= -1 ? 'statement active' : 'statement'} style={{ fontSize: fSize, width: cWidth }}>
              <img src="statement.png" alt="" />
            </div>
          </main>
        </Html>
      )}

      {userLang == 'en' && (
        <Html ref={htmlRefEn}
          // position={[3.6, 0, -4.6]}
          // rotation={[0, -0.5, 0]}
          transform occlude>
          <main className="caption">
            <div className={mode >= -1 ? 'statement active' : 'statement'} style={{ fontSize: fSize, width: cWidth }}>
              <img src="statement_en.png" alt="" />
            </div>
          </main>
        </Html>
      )}

    </group>
  )
})
